import { createSlice, createAsyncThunk} from '@reduxjs/toolkit';
import blockService from './blockService';

const initialState = {
  socialBlock: '',
  isSocialBlockError: false,
  isSocialBlockSuccess: false,
  isSocialBlockLoading: false,
  isSocialBlockErrorMsg: '',
};

export const creatingSocialBlock = createAsyncThunk(
  'socialBlock/creatingSocialBlock',

  async (headingkData, thunkAPI) => {
    // alert()

    try {
      const response = await blockService.creatingSocialBlock(headingkData);
      return response;
    } catch (error) {
      const isSocialBlockErrorMsg =
        (error.response && error.response.data && error.response.data.isSocialBlockErrorMsg) ||
        error.isSocialBlockErrorMsg ||
        error.toString();
      return thunkAPI.rejectWithValue(isSocialBlockErrorMsg);
    }
  }
);
export const socialSlice = createSlice({
  name: 'socialBlock',
  initialState,
  reducers: {
    resetUser: (state) => {
      state.isSocialBlockLoading = false;
      state.isSocialBlockSuccess = false;
      state.isSocialBlockError = false;
      state.isSocialBlockErrorMsg = '';
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(creatingSocialBlock.pending, (state) => {
        state.isSocialBlockLoading = true;
      })
      .addCase(creatingSocialBlock.fulfilled, (state, action) => {
        state.isSocialBlockLoading = false;
        state.isSocialBlockSuccess = true;
        state.socialBlock = action.payload;
      })
      .addCase(creatingSocialBlock.rejected, (state, action) => {
        state.isSocialBlockLoading = false;
        state.isSocialBlockError = true;
        state.isSocialBlockErrorMsg = action.payload; // error from catch will come here via action.payload and update isSocialBlockErrorMsg
      });
  },
});
export const { resetUser } = socialSlice.actions;
export default socialSlice.reducer;
